// @core/api/endpoints/project/get_velocity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  VelocityResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Get velocity chart
 * Returns velocity data showing story points completed per sprint over time. Useful for capacity planning and forecasting.
 */
export async function GetVelocity(
  project_id: string,
  options?: RequestOptions
): Promise<VelocityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/velocity`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.get<VelocityResponse>(requestPath, { ...requestOptions });
}
